import { useState } from 'react';

import { useMsal } from "@azure/msal-react";

import { TicketChangeLog } from '../../../../../../api-client';
import { IHookCallback } from '../../../../../../common/models/IHookCallback';
import { TicketApiClient } from '../../../../../../providers/api-provider';
import { NotificationHelper } from '../../../../../../utils/notification';
import { useTranslation } from 'react-i18next';
import helpers from '../../../../../../utils/helpers/helpers';

export const useTicketsPivot = () => {
    const {
        instance
    } = useMsal();

    const {
        t: translate
    } = useTranslation();

    interface IRetrieveChangeLogs extends IHookCallback {
        id: string;
        onRetrieveSuccess: (changeLogs: TicketChangeLog[]) => void;
    }

    const [retrieveChangeLogs, setRetrieveChangeLogs] = useState<TicketChangeLog[]>();
    const [retrieveChangeLogsLoading, setRetrieveChangeLogsLoading] = useState<boolean>(false);

    const handleRetrieveChangeLogs = async (params: IRetrieveChangeLogs) => {
        setRetrieveChangeLogsLoading(true);

        const clientApi = await TicketApiClient(instance, helpers.getStoredI18Lang());
        clientApi.getTicketChangeLogs(params.id)
            .then((response) => {
                setRetrieveChangeLogs(response.data);

                params.onRetrieveSuccess(response.data);
            })
            .catch((reason) => {
                setRetrieveChangeLogs([]);

                params.onError && params.onError();

                NotificationHelper.createNotification({
                    type: 'error',
                    message: translate('system.notification.getTicketPivotChangeLogs.title'),
                    title: translate('system.notification.getTicketPivotChangeLogs.message')
                });
            })
            .finally(() => {
                setRetrieveChangeLogsLoading(false);

                params.onAlways && params.onAlways();
            });
    }

    return {
        handleRetrieveChangeLogs,
        retrieveChangeLogs,
        retrieveChangeLogsLoading
    }
}